import axios from "axios";
import {
  clearSession,
  getUserDetails,
  isSessionValid,
} from "../utils/sessionUtils";
import { getApiBaseUrl } from "../utils/helpers";
import { toast } from "react-toastify";

export const getHeaders = () => {
  toast.dismiss();

  // console.log("!Get headers called...");
  const isAuthenticated = isSessionValid();
  console.log("!Authenticated: ", isAuthenticated);
  if (isAuthenticated) {
    const { profileId, zoneKey, userCode, userId, counterKey } =
      getUserDetails();
    return {
      "Profile-ID": profileId,
      "Zone-Key": zoneKey,
      "User-Code": userCode,
      "User-ID": userId,
      "counter-key": counterKey,
    };
  } else {
    clearSession();
    window.location.reload();
  }
};

const apiClient = axios.create({
  baseURL: getApiBaseUrl(),
});

// Add a request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Get the headers from getHeaders function
    const headers = getHeaders();

    // Attach the headers to the config
    config.headers = {
      ...config.headers,
      ...headers,
    };

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

export default apiClient;
